import React from 'react';
import {connect} from 'react-redux';
// Shared imports
import settings from '../../../../settings';
import { redirectTo } from '../../../../SharedUI/functions';

class PublishSuccess extends React.Component {
    getUsername = () => {
        const { user } = this.props;
        return user.username;
    }

    goto = (page) => {
        const { protocol } = window.location;
        const slashes = protocol.concat('//');
        const pageUrl = slashes.concat(`${window.location.hostname}/${page}`);
        window.location.href = pageUrl;
    }

    onCreateNew = () => {
        // Navigate user to the start of the gameguide
        redirectTo('maak');
    }

    onGames = () => {
        // Navigate user to 'games'
        redirectTo('games');
    }

    render = () => {
        const { game, gameKit } = this.props;
        const mmLink = gameKit.mmSessionId && gameKit.mmApiUrl ? (
            <a target="_blank" href={`${gameKit.mmApiUrl.replace('[mmSessionId]', gameKit.mmSessionId)}`}>
                <img className="bitcode" src={`${settings.assetsPath}img/bits-banner-2021.png`} alt="Link naar MediaMasters" />
            </a>
        ) : '';
        
        return (
            <div className="publish-success-container">
                <h1>{this.getUsername()}</h1>
                <p>Jouw game staat online bij '<span>games</span>'</p>
                <img src={`${settings.assetsPath}img/publish_success_cactus.png`} alt="Blije cactus" />
                <div className="publish-success-buttons">
                    <button 
                        type="button"
                        onClick={this.onCreateNew}
                        className="btn-create-new"
                    >
                        nog een game maken
                    </button>
                    <button 
                        type="button"
                        onClick={this.onGames}
                        className="btn-games"
                    >
                        ga naar games
                    </button>
                </div>
                {mmLink}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    gameKit: state.gameKit,
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps
)(PublishSuccess);
